export default () => {
  return {
    feed: [],
    newItems: [],
    limit: 50,
    minTimestamp: null,
    maxTimestamp: null,
    group_id: null
  }
}
